import { render, staticRenderFns } from "./ModalItemDraftingCancelKirimBalik.vue?vue&type=template&id=4f475b18&"
import script from "./ModalItemDraftingCancelKirimBalik.vue?vue&type=script&lang=js&"
export * from "./ModalItemDraftingCancelKirimBalik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports